import { MatDialogRef } from '@angular/material/dialog';

export abstract class DialogWrapper<T = any, Data = any, Return = any> {
  public abstract dialogRef: MatDialogRef<T, Return>;
  public abstract matDialogData: Data;

  public open = true;

  public onClosed(): void {
    this.dialogRef.close();
  }

  public close = (): void => {
    this.dialogRef.close();
  };
}
